import React from 'react'
import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image'
import Hero from '../pages/hero.png'

const Banner = () => {
    const data = useStaticQuery(graphql`
       query Images {
           image: file(relativePath: {eq: "hero.png"}) {
            id
            childImageSharp {
               fixed{
                   ...GatsbyImageSharpFixed
               }
               fluid {
                   ...GatsbyImageSharpFluid
               }
            }
          }
       }
    `)
    console.log(data)
    return ( 
        <div>
            <Img  fluid={data.image.childImageSharp.fluid} />
        </div>
     );
}
 
export default Banner;